import React from 'react';
export function BuyConfigInfo(_a) {
    var style = _a.style, children = _a.children, title = _a.title;
    return (React.createElement("div", { className: "buy-config-form-info", style: style },
        title && React.createElement("h3", { className: "buy-info-title" }, title),
        children));
}
export function BuyConfigSubInfo(_a) {
    var style = _a.style, children = _a.children, title = _a.title;
    return (React.createElement("div", { className: "buy-config-form-info buy-config-form-main-info", style: style },
        React.createElement("div", { className: "buy-main-info__container" },
            React.createElement("h3", { className: "buy-main-info-title" }, title),
            children)));
}
export function BuyConfigMultiInfo(_a) {
    var style = _a.style, children = _a.children;
    var subAmount = React.Children.toArray(children).length;
    return (React.createElement("div", { className: "buy-config-form-info buy-config-form-main-info " + (subAmount > 2 ? 'buy-config-form-info__multi' : ''), style: style }, children));
}
export function BuyConfigMultiInfoCol(_a) {
    var style = _a.style, children = _a.children;
    return (React.createElement("div", { className: "buy-main-info__container", style: style }, children));
}
//# sourceMappingURL=BuyConfigInfo.js.map